module.exports = __webpack_public_path__ + "static/media/svg-shape.59cf62f4.svg";